import { useEffect } from 'react';
import { useAnimate, useReducedMotion } from 'framer-motion';

const NUDGE_KEYFRAMES_PX = [0, -4, 4, -3, 2, 0];
const NUDGE_DURATION_S = 0.35;

export function useQueryPanelShake(shakeNonce: number) {
    const [scope, animate] = useAnimate();
    const prefersReducedMotion = useReducedMotion();

    useEffect(() => {
        if (shakeNonce === 0 || prefersReducedMotion || !scope.current) {
            return;
        }
        void animate(
            scope.current,
            { x: NUDGE_KEYFRAMES_PX },
            { duration: NUDGE_DURATION_S, ease: 'easeInOut' },
        );
    }, [shakeNonce, prefersReducedMotion, animate, scope]);

    return scope;
}
